import React from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, PlusCircle } from "lucide-react";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

export function EnrichModal({
  isEnrichModalOpen, setIsEnrichModalOpen,
  enrichEmailContent, setEnrichEmailContent,
  isEnriching, handleEnrich,
}) {
  return (
    <Dialog open={isEnrichModalOpen} onOpenChange={setIsEnrichModalOpen}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-['Manrope']">
            <PlusCircle className="w-5 h-5 text-orange-500" />
            Compléter avec un autre email
          </DialogTitle>
          <DialogDescription>
            Collez un email supplémentaire (ex: confirmation de paiement) pour enrichir les données de la commande.
            Les nouvelles informations compléteront les données existantes sans les écraser.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Textarea
            value={enrichEmailContent}
            onChange={(e) => setEnrichEmailContent(e.target.value)}
            placeholder="Collez ici l'email de paiement ou de confirmation..."
            className="min-h-[250px] font-mono text-sm resize-y"
            data-testid="enrich-email-input"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => { setIsEnrichModalOpen(false); setEnrichEmailContent(""); }}>
            Annuler
          </Button>
          <Button
            onClick={handleEnrich}
            disabled={isEnriching || !enrichEmailContent.trim()}
            className="bg-orange-500 hover:bg-orange-600 text-white gap-2"
            data-testid="enrich-submit-btn"
          >
            {isEnriching ? (
              <><Loader2 className="w-4 h-4 animate-spin" />Enrichissement...</>
            ) : (
              <><PlusCircle className="w-4 h-4" />Compléter la commande</>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
